import { Button } from "@/components/ui/button";
import CitySelector from "@/components/jobbkarta/CitySelector";
import { GuideCard } from "@/components/jobbkarta/GuideCard";
import { Sparkles, Briefcase, MapPinned, Compass, UserRound } from "lucide-react";

export default function Landing({ cities, selected, onToggle, onStart, onOpenProfile }) {
  return (
    <div className="relative mx-auto flex min-h-[calc(100vh-4rem)] max-w-5xl flex-col items-center justify-center px-5 py-10">
      <div className="jk-fade-up w-full text-center">
        <span className="inline-flex items-center gap-2 rounded-full border border-emerald-200 bg-emerald-50 px-3 py-1 text-xs font-semibold uppercase tracking-wider text-emerald-700">
          <Compass className="h-3.5 w-3.5" /> Hitta jobb via kartan
        </span>
        <h1 className="mx-auto mt-5 max-w-3xl font-display text-3xl font-extrabold leading-tight tracking-tight text-slate-900 sm:text-5xl">
          Sök jobb där annonserna <span className="text-emerald-600">inte</span> finns.
        </h1>
        <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-slate-600 sm:text-lg">
          Välj en stad, utforska företag på kartan och skicka en spontanansökan direkt – med
          hjälp av en AI som skriver ett proffsigt mail åt dig. Du ser även lediga jobb som
          redan är utlysta i området.
        </p>

        <div className="mx-auto mt-8 flex w-full max-w-md flex-col items-center gap-3">
          <div className="flex w-full flex-col items-stretch gap-2 sm:flex-row sm:items-center sm:justify-center">
            <CitySelector
              presets={cities}
              selected={selected}
              onToggle={onToggle}
              triggerClassName="h-11 w-full sm:w-auto justify-center"
            />
            <Button
              onClick={onStart}
              disabled={selected.length === 0}
              data-testid="landing-explore-btn"
              className="h-11 gap-2 rounded-full bg-emerald-600 px-6 text-base hover:bg-emerald-700"
            >
              <MapPinned className="h-4 w-4" /> Utforska jobbkartan
            </Button>
          </div>
        </div>
      </div>

      <div className="mt-14 grid w-full gap-4 sm:grid-cols-3">
        {[
          {
            icon: Sparkles,
            color: "emerald",
            title: "Företag utan annons",
            text: "Hitta företag i staden och ta kontakt innan tjänsten ens utlysts.",
          },
          {
            icon: Briefcase,
            color: "blue",
            title: "Utlysta jobb",
            text: "Se riktiga platsannonser från Arbetsförmedlingen och ansök direkt.",
          },
          {
            icon: UserRound,
            color: "slate",
            title: "AI skriver mailet",
            text: "Få ett personligt, professionellt jobbmail – som du själv kan redigera.",
          },
        ].map((f, i) => (
          <div
            key={i}
            className="jk-fade-up rounded-2xl border border-slate-200 bg-white p-5 text-left shadow-sm"
            style={{ animationDelay: `${i * 80}ms` }}
          >
            <span
              className={`mb-3 flex h-10 w-10 items-center justify-center rounded-xl ${
                f.color === "emerald"
                  ? "bg-emerald-100 text-emerald-700"
                  : f.color === "blue"
                  ? "bg-blue-100 text-blue-700"
                  : "bg-slate-100 text-slate-700"
              }`}
            >
              <f.icon className="h-5 w-5" />
            </span>
            <h3 className="font-display text-base font-semibold text-slate-900">{f.title}</h3>
            <p className="mt-1 text-sm text-slate-500">{f.text}</p>
          </div>
        ))}
      </div>

      <GuideCard />
    </div>
  );
}
